module.exports = __webpack_public_path__ + "static/media/29FUNOV1.61c04219.jpg";